import { Session } from "next-auth";
import { MCPermissions } from "~/common/constants";

export const getUserPermissionsForAssets = (session?: Session | null) => {
  if (!session) {
    return [];
  }

  return [
    session.user.pro?.economicPlus ? MCPermissions.PRO_ECONOMIC_PLUS : null,
    session.user.pro?.politicalPlus ? MCPermissions.PRO_POLITICAL_PLUS : null,
    session.user.pro?.consumerPlus ? MCPermissions.PRO_CONSUMER_PLUS : null,
    session.user.pro?.fullAccess ? MCPermissions.PRO_FULL_ACCESS_PERM : null,
    session.user.applications?.pro ? MCPermissions.PRO_PERM : null,
  ].filter(Boolean) as MCPermissions[];
};

export const requiresPlusPermissions = (requiredPermission: MCPermissions[]) =>
  requiredPermission.some((perm) =>
    [
      MCPermissions.PRO_ECONOMIC_PLUS,
      MCPermissions.PRO_POLITICAL_PLUS,
      MCPermissions.PRO_CONSUMER_PLUS,
    ].includes(perm)
  );

export const canDownloadAsset = (
  requiredPermissionsWithPublic: (MCPermissions | "public")[],
  userPermissions: MCPermissions[]
) => {
  if (requiredPermissionsWithPublic.includes("public")) {
    return true;
  }

  const requiredPermissions = requiredPermissionsWithPublic as MCPermissions[];

  return requiredPermissions.some((perm) => userPermissions.includes(perm));
};
